.editor {
  background-color: #eee;
  border-radius: .25em;
  padding: 1em;
}

.button {
  visibility: hidden;
  margin-top: 20px;
  padding: 2px 7px;
  font-size: 16px;
  font-family: Courier New,Courier,monospace;
  cursor: pointer;
  pointer-events: none;
  appearance: none;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: #eee;

  .root:hover &,
  .editor:hover &,
  .editor:focus & {
    visibility: visible;
    pointer-events: auto;
  }

  &:hover {
    opacity: .5;
  }
}

@media (hover: none) {
  .button {
    position: relative;
    top: 100%;
  }
}
